import React from 'react';
import Navigation from '../components/Navigation';

const BookingPage = () => {
  console.log('Navigation:', Navigation);
  
  return (
    <div>
      <h1>Testing Navigation Alone</h1>
      <Navigation />
    </div>
  );
};

export default BookingPage;